import { useSideDrawer } from '@/domain/hooks/useSideDrawer'
import { useUnifiedPortfolio } from '@/features/portfolio/logic/useUnifiedPortfolio'
import { useEffect } from 'react'

export function useAccountOverview() {
  const portfolio = useUnifiedPortfolio()
  const { positionsTab } = useSideDrawer()
  const { highestRiskLevel, setHighestRiskLevel, setShowPositionsBadge } = positionsTab
  const currentHighestRiskLevel = portfolio.positionData.highestRiskLevel

  useEffect(() => {
    if (currentHighestRiskLevel !== highestRiskLevel) {
      setHighestRiskLevel(currentHighestRiskLevel)
      setShowPositionsBadge(true)
    }
  }, [currentHighestRiskLevel, highestRiskLevel, setHighestRiskLevel, setShowPositionsBadge])

  return portfolio
}
